import { status } from '../../config.ts'

import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'POST',
    path: '/movistar/import',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/zone_u/import',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
